import Model, { attr } from '@ember-data/model';
import adapter from 'garaje/utils/decorators/adapter';

@adapter('mac-address-mapping')
class MacAddressMappingModel extends Model {
  @attr('string') declare macAddress: string;
  @attr('string') declare employeeName: string;
  @attr('string') declare employeeEmail: string;
  @attr('number') declare employeeId: number;
  @attr('number') declare companyId: number;
  @attr('string') declare source: string;
  @attr('date') declare lastSyncedAt: Date;
  @attr('date') declare createdAt: Date;
  @attr('date') declare updatedAt: Date;
}

export default MacAddressMappingModel;

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'mac-address-mapping': MacAddressMappingModel;
  }
}
